// Copyright (C) 2020-2022 Intel Corporation
// Copyright (C) 2022-2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React, { useState } from 'react';

import Form from 'antd/lib/form';
// import Button from 'antd/lib/button';
// import Input from 'antd/lib/input';
import { Col } from 'antd/lib/grid';
import Title from 'antd/lib/typography/Title';
// import Text from 'antd/lib/typography/Text';
// import Icon from '@ant-design/icons';
// import {
//     BackArrowIcon, ClearIcon,
// } from 'icons';

// import CVATSigningInput, { CVATInputType } from 'components/signing-common/cvat-signing-input';
// import { CombinedState } from 'reducers';
// import { usePlugins } from 'utils/hooks';
// import config from 'config'

export interface LoginData {
    credential: string;
    password: string;
}

interface Props {
    renderResetPassword: boolean;
    fetching: boolean;
    onSubmit(loginData: LoginData): void;
    socialAuthentication: JSX.Element | null;
}

function LoginFormComponent(props: Props): JSX.Element {
    const {
         onSubmit, socialAuthentication,
    } = props;

    console.log(socialAuthentication);

    const [form] = Form.useForm();
    const [credential, setCredential] = useState('');
    // const pluginsToRender = usePlugins(
    //     (state: CombinedState) => state.plugins.components.loginPage.loginForm,
    //     props, { credential },
    // );

    // const forgotPasswordLink = (
    //     <Col className='cvat-credentials-link'>
    //         <Text strong>
    //             <Link to={credential.includes('@') ?
    //                 `/auth/password/reset?credential=${credential}` : '/auth/password/reset'}
    //             >
    //                 Forgot password?
    //             </Link>
    //         </Text>
    //     </Col>
    // );

    return (
        <div className='cvat-login-form-wrapper'>

            <Col>
                <Title level={2}> Press the button below to access the label tool </Title>
            </Col>
            <Form
                className={`cvat-login-form ${credential ? 'cvat-login-form-extended' : ''}`}
                form={form}
                onFinish={(loginData: LoginData) => {
                    onSubmit(loginData);
                }}
            >
                {
                    socialAuthentication
                }
                {/* {
                    pluginsToRender.map(({ component: Component }, index) => (
                        <Component targetProps={props} targetState={{ credential }} key={index} />
                    ))
                } */}
            </Form>
        </div>
    );
}

export default React.memo(LoginFormComponent);
